var ConexaoSeguraEnum = {
    SSL: {
        enumName: 'SSL',                      
        name: 'SSL'
    },
    TLS: {
        enumName: 'TLS',  
        name: 'TLS'      
    },
    get(value) {        
        if(value === null)
            return ConexaoSeguraEnum.SSL;

        var array = Object.values(ConexaoSeguraEnum);
        var conexaoSeguraEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                conexaoSeguraEnumFound = element;      
                return ;          
            }            
        });   
        
        return conexaoSeguraEnumFound;
    },
    list() {
        var array = Object.values(ConexaoSeguraEnum);
        var conexaoSeguraEnumList = [];                          

        array.forEach(element => {            
            if((element.name === 'get')||(element.name === 'list'))
                return ;

            var conexao = {};

            conexao.valor = element.enumName;
            conexao.texto = element.name;

            conexaoSeguraEnumList.push(conexao);
        });

        return conexaoSeguraEnumList;
    }
}

export default ConexaoSeguraEnum;